import { render, staticRenderFns } from "./order_add.vue?vue&type=template&id=16f95df5&scoped=true&"
import script from "./order_add.vue?vue&type=script&lang=js&"
export * from "./order_add.vue?vue&type=script&lang=js&"
import style0 from "./order_add.css?vue&type=style&index=0&id=16f95df5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f95df5",
  null
  
)

export default component.exports